import { Route } from 'react-router';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';
import { TwoFAPage } from '@/bundle/Auth/LoginFlow/TwoFAPage/TwoFAPage';
import { getTwoFAPath } from '@/bundle/Auth/LoginFlow/TwoFAPage/path/path';
import { getPinCodePath } from '@/bundle/Auth/LoginFlow/CheckPinCodePage/path/path';
import { CheckPinCodePage } from '@/bundle/Auth/LoginFlow/CheckPinCodePage/CheckPinCodePage';
import { AUTH_STEP } from '../const/const';
import { AuthProtectedRoute } from '@/bundle/Routes/AuthProtectedRoute';
import { getSelectRolePath } from '@/bundle/Auth/LoginFlow/SelectRolePage/path/path';
import { SelectRolePage } from '../LoginFlow/SelectRolePage/SelectRolePage';
import { getPersonalDetailsVerificationPath } from '@/bundle/Auth/LoginFlow/PersonalDetailsVerificationPage/path/path';
import { PersonalDetailsVerificationPage } from '../LoginFlow/PersonalDetailsVerificationPage/PersonalDetailsVerificationPage';
import { getLoginVerifyPasswordPath } from '@/bundle/Auth/LoginFlow/LoginVerifyPassword/path/path';
import { LoginVerifyPassword } from '@/bundle/Auth/LoginFlow/LoginVerifyPassword/LoginVerifyPassword';
import { LoginPage } from '../LoginFlow/LoginPage/LoginPage';

export const LOGIN_FLOW_ROUTES = [
  <Route key={getLoginPath()} path={getLoginPath()} element={<LoginPage />} />,
  <Route
    key={getLoginVerifyPasswordPath()}
    path={getLoginVerifyPasswordPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.PASSWORD_AUTHENTICATION}>
        <LoginVerifyPassword />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getTwoFAPath()}
    path={getTwoFAPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.TWO_FACTOR_AUTHENTICATION}>
        <TwoFAPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getPinCodePath()}
    path={getPinCodePath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.PIN_AUTHENTICATION}>
        <CheckPinCodePage />
      </AuthProtectedRoute>
    }
  />,
  <Route key={getSelectRolePath()} path={getSelectRolePath()} element={<SelectRolePage />} />,
  <Route
    key={getPersonalDetailsVerificationPath()}
    path={getPersonalDetailsVerificationPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.SET_NAME_VERIFICATION}>
        <PersonalDetailsVerificationPage />
      </AuthProtectedRoute>
    }
  />,
];
